import { render, staticRenderFns } from "./CheckPerson.vue?vue&type=template&id=ae389f92"
import script from "./CheckPerson.vue?vue&type=script&lang=js"
export * from "./CheckPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports